import {
  getPageHeader,
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
  PageContainer,
  PageHeader,
  PageHeaderLeading,
} from '@yeshuman/sdk'
import { CalendarCheck } from 'lucide-react'

export function PractitionerConsultationsPage() {
  const { title, description } = getPageHeader(
    '/consultations',
    'Consultations',
    'Patient-prepared consultation packs (practitioner inbox coming later).',
  )
  return (
    <PageContainer>
      <PageHeader
        leading={<PageHeaderLeading />}
        title={title}
        description={description}
        icon={<CalendarCheck className="h-5 w-5" />}
      />
      <Card>
        <CardHeader>
          <CardTitle>Patient-owned prep packs</CardTitle>
          <CardDescription>
            Patients can prepare consultation packs with Lumie and share them via a secret link or
            PDF. A practitioner inbox for linked patients is not part of this release.
          </CardDescription>
        </CardHeader>
        <CardContent className="text-sm text-muted-foreground">
          If a patient sends you a share link, open it to review their prep pack — no login
          required for the shared view.
        </CardContent>
      </Card>
    </PageContainer>
  )
}
